module.exports = __webpack_public_path__ + "img/game_1_1.5c893300.png";